<!-- LOADING -->
<div *ngIf="loading;" class="d-flex justify-content-center align-items-center" style="height: 96px;">
  <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
</div>
<!-- NOT-LOADING -->
<ng-container *ngIf="!loading" class="row m-0 p-0">
  <!-- FILTERS -->
  <div class="d-flex justify-content-end">
    <button class="ms-auto" mat-stroked-button color="primary" (click)="showFilterDialog()">
      Filtri
    </button>
  </div>
  <div class="v-spacer"></div>
  <!-- FILTERS -->
  <!-- ERROR -->
  <div *ngIf="error;" class="d-flex flex-column justify-content-center align-items-center gap-3" style="height: 96px;">
    <div>{{error.message}}</div>
  </div>
  <!-- ERROR -->
  <!-- DATA -->
  <div *ngIf="error === undefined;" class="row m-0 p-0">
    <div class="col-auto m-0 p-0">
      <div class="user-img-spacer"></div>
    </div>
    <div class="col m-0 p-0 ps-3">
      <table class="table table-borderless m-0">
        <thead class="m-0">
          <tr class="dea-table-row-header m-0">
            <th scope="col">Modulo</th>
            <th scope="col">Classe</th>
            <th scope="col">Materia</th>
            <th scope="col">Data Creazione</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let form of forms;" class="guest-attendance-listing-table-row dea-radius">
            <td class="col py-auto">{{form.title}}</td>
            <td class="col py-auto">{{form.getClasses().join(',')}}</td>
            <td class="col py-auto">{{form.getSubjects().join(',')}}</td>
            <td class="col py-auto">{{form.createdAt | date:'yyyy-MM-dd'}}</td>
            <td class="col py-auto">
              <mat-icon class="m-0 p-0 opacity-25 dea-mat-icon-btn" (click)="showPdfPreviewPDF(form.id)"
                title="Visualizza {{form?.title}}">
                visibility
              </mat-icon>
              <mat-icon class="ms-3 m-0 p-0 opacity-25 dea-mat-icon-btn" (click)="downloadFormPDF(form.id)"
                title="Download: {{form?.title}}">
                download
              </mat-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- DATA -->
</ng-container>